import { useEffect, useState } from "react";
import { message } from "antd";
import CrudHeader from "../CrudHeader";
import EstadoFinancieroTable from "./EstadoFinancieroTable";
import EstadoFinancieroForm from "./EstadoFinancieroForm";
import { getEstados, createEstado, updateEstado, deleteEstado } from "../../../../services/financiero/finEstadoService";
import { useSelector } from 'react-redux';
import { selectAppPermissions } from '../../../../store/auth/selectors';

export default function EstadoFinancieroPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const appName = 'estado_financiero';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;
  const permissionDelete = permissions.priv_delete === 'Y';
  const permissionUpdate = permissions.priv_update === 'Y';
  const permissionInsert = permissions.priv_insert === 'Y';

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await getEstados();
      setData(res);
    } catch {
      message.error("Error cargando estados");
    }
    setLoading(false);
  };

  useEffect(() => {
    cargar();
  }, []);

  const handleCreate = () => {
    setEditing(null);
    setModalOpen(true);
  };

  const handleEdit = (record) => {
    setEditing(record);
    setModalOpen(true);
  };

  const handleDelete = async (record) => {
    if (!permissionDelete) {
      message.warning("No tiene permisos para eliminar");
      return;
    }
    await deleteEstado(record.oid, userLogin);
    message.success("Estado eliminado");
    cargar();
  };

  const handleSubmit = async (values) => {
    if (editing) {
      if (!permissionUpdate) {
        message.warning("No tiene permisos para editar");
        return;
      }
      await updateEstado(editing.oid, values, userLogin);
      message.success("Estado actualizado");
    } else {
      if (!permissionInsert) {
        message.warning("No tiene permisos para crear");
        return;
      }
      await createEstado(values, userLogin);
      message.success("Estado creado");
    }
    setModalOpen(false);
    cargar();
  };

  return (
    <div>
      <CrudHeader
        title="Estados Financieros"
        onCreate={handleCreate}
        permissionInsert={permissionInsert}
      />
      <div style={{ maxWidth: 900, margin: "0 auto", }}>
        <EstadoFinancieroTable
          data={data}
          loading={loading}
          onEdit={handleEdit}
          onDelete={handleDelete}
          permissionUpdate={permissionUpdate}
          permissionDelete={permissionDelete}
        />
      </div>
      <EstadoFinancieroForm
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSubmit={handleSubmit}
        initialValues={editing}
      />
    </div>
  );
}